import _ from 'lodash'
let config = {}
/* const initConfig = function () {
  let cc = {}
  cc = _.merge({}, require('./base.config'), require('./env/prod.config'))

  if (process.env.VUE_APP_BUILD_ENV) {
    cc = _.merge({}, cc, require(`./env/${process.env.VUE_APP_BUILD_ENV}.config`))
  } else {
    if (process.env.NODE_ENV === 'development') {
      try {
        // 动态去搜寻local.config.js,如果有local.config.js，就使用local.config.js ,否则使用 /env/dev.config
        const localConfigContext = require.context('./', false, /local\.config\.js$/)
        const requireAll = (context) => context.keys().map(context)
        const localConfig = requireAll(localConfigContext)[0]
        const c = localConfig || require('./env/dev.config')
        cc = _.merge({}, cc, c)
      } catch (e) {}
    }
  }
  return cc
} */

const initConfig = function () {
  console.log('当前 NODE_ENV:', process.env.NODE_ENV) // 调试日志

  // 基础配置
  const config = _.merge({}, require('./base.config'))

  // 根据环境加载配置
  if (process.env.NODE_ENV === 'development') {
    console.log('加载开发配置')
    _.merge(config, require('./env/dev.config'))
  } else {
    console.log('加载生产配置')
    _.merge(config, require('./env/prod.config'))
  }

  // 动态覆盖（如 VUE_APP_BUILD_ENV=test）
  if (process.env.VUE_APP_BUILD_ENV) {
    const dynamicConfig = require(`./env/${process.env.VUE_APP_BUILD_ENV}.config`)
    console.log(`动态加载覆盖配置: ${process.env.VUE_APP_BUILD_ENV}.config`)
    _.merge(config, dynamicConfig)
  }

  console.log('最终配置:', config)
  return config
}
config = initConfig()
export default config
